<template>
   <span class="gts-badge" :class="`${classPrefix}-${status}`">{{ label }}</span>
</template>

<script>
export default {
   name: "TaskRequestStatusBadge",
   props: {
      status: {
         type: Number,
         required: true,
      },
      label: {
         type: String,
         required: true,
      },
      classPrefix: {
         type: String,
         default: "ETaskStatus",
      },
   },
};
</script>

<style lang="scss" scoped>
.gts-badge {
   display: inline-flex;
   align-items: center;
   padding: 0.25rem 0.5rem;
   border-radius: 4px;
   font-size: 13px;
   font-weight: 600;
   line-height: 1.2;
   white-space: nowrap;
}
</style>
